import Box from '@mui/material/Box'

const FontStyle = ({ name }) => (
  <Box
    sx={(theme) => ({
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: 83,
      justifyContent: 'center',
      width: 113,
      '& *': {
        color: theme.palette.tertiary.main,
        fontFamily: name,
        fontWeight: 600
      }
    })}
  >
    <Box component='span' sx={{ fontSize: 30 }}>Aa</Box>
    <Box component='span' sx={{ fontSize: 14 }}>{name}</Box>
  </Box>
)

export default FontStyle
